import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./PublicTemplates.module.css";
import { Col, List, Row, Space } from "antd";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronForward } from "react-icons/io5";
import myTemplate1 from "../../../../assets/staticImages/MyTemplate1.png";
import myTemplate2 from "../../../../assets/staticImages/MyTemplate2.png";
import myTemplate3 from "../../../../assets/staticImages/MyTemplate3.png";
import { useEffect, useState } from "react";
import Modal from "../../../../components/modal/Modal";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { PlanningTemplatesMiddleware } from "../../../../Store/Middlewares/PlanningTemplatesMiddleware";
import moment from "moment";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import dummyImg from "../../../../assets/dummy.jpg";

const headerRow = {
  firstCol: "Created By",
  secondCol: "Date Created",
  thirdCol: "",
};

const guestsRows = [
  {
    title: "Engagement Ceremony",
    type: "Wedding",
    date: "09 Feb 2023",
    img: myTemplate1,
  },
  {
    title: "Cocktail Party",
    date: "09 Feb 2023",
    type: "Wedding",
    img: myTemplate2,
  },
  {
    title: "Reception Ceremony",
    date: "09 Feb 2023",
    type: "Wedding",
    img: myTemplate3,
  },
];

const TableHeader = ({ item }) => {
  return (
    <Row className={styles.listItemFirst}>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.firstCol} />
          </Col>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.secondCol} />
          </Col>
          <Col lg={10} xl={8} className={styles.group2Col}>
            <TextComponent text={item.thirdCol} textClass={styles.guests} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const RenderTemplate = ({
  item,
  setAddTemplate,
  setevent,
  addPlanningTemplate,
  eventData,
}) => {
  const navigate = useNavigate();
  return (
    <List.Item
      className={styles.listItem}
      onClick={() =>
        navigate(
          eventData
            ? "/events/eventDetail/templates/vendor/templateDetail"
            : "/templates/vendor/templateDetail",
          {
            state: {
              headrTitle: "Planning Forms",
              publicTemplate: true,
              item: item,
              eventData: eventData,
              screenType: "Planning Forms",
            },
          }
        )
      }
    >
      <Col xs={24} lg={9} >
        <LeftGroup item={item}
         />
      </Col>
      <Col xs={24} lg={15} >
        <RightGroup
          item={item}
          setAddTemplate={setAddTemplate}
          setevent={setevent}
          addPlanningTemplate={addPlanningTemplate}
        />
      </Col>
    </List.Item>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <img src={item?.vendor_image ? item?.vendor_image : dummyImg}></img>
      <div className={styles.textGroup}>
        <TextComponent
          text={item?.title ? item?.title : "--"}
          textClass={styles.eventTitle}
        />
      </div>
    </div>
  );
};

const RightGroup = ({
  item,
  setAddTemplate,
  setevent,
  addPlanningTemplate,
}) => {
  const navigate = useNavigate();
  return (
    <Row gutter={[0, 16]} className={styles.itemGroup2}>
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Created By" textClass={styles.infoTitle} />
        <TextComponent text={item?.vendor_name ? item?.vendor_name : "--"} />
      </Col>
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Date Created" textClass={styles.infoTitle} />
        <TextComponent text={moment(item?.event_date).format("MMM DD YYYY")} />
      </Col>
      <Col xs={24} sm={8} lg={10} xl={8} className={styles.group2Col}>
        <TextComponent text="" textClass={styles.infoTitle} />
        <Col xs={24} sm={{ span: 22, offset: 1 }} lg={19}>
          <SubmitButton
            title="Add to my planning"
            btnClass={styles.templateBtn}
            onClick={(e) => {
              e.stopPropagation(); 
              addPlanningTemplate(item?.id);
            }}
            // onClick={(e) => {
            //   e.stopPropagation();
            //   setAddTemplate(true);
            //   setevent({ temp_id: item?.id });
            // }}
          />
        </Col>
        <IoChevronForward className={styles.rightIcon} />
      </Col>
    </Row>
  );
};

const PublicTemplates = () => {
  const { width } = useWindowDimensions();
  const [addTemplate, setAddTemplate] = useState(false);
  const [event, setevent] = useState();
  const PublicTemplates = useSelector(
    (state) => state?.PlanningTemplatesReducer.PublicTemplates
  );
  // console.log("PublicTemplates", PublicTemplates);
  const VendorEvents = useSelector(
    (state) => state?.PlanningTemplatesReducer.VendorEvents
  );

  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  // console.log("event", event);

  const dispatch = useDispatch();
  const { state } = useLocation();
  console.log("statepublicTemp||||||||||||||||", EventDetails);
  useEffect(() => {
    dispatch(
      PlanningTemplatesMiddleware.getPublicTemplates({
        event_id: state?.eventData?.id,
      })
    );
    // dispatch(PlanningTemplatesMiddleware.getVendorEvents());
  }, []);

  // const addPlanningTemplate = () => {
  //   if (!event) {
  //     dispatch(showAlert({
  //       type: "Error",
  //       message: "Select event!"
  //     }))
  //     return;
  //   } else {
  //     setAddTemplate(false);
  //     let eventData = {
  //       event_id: event?.selected_event?.id,
  //       temp_id: event?.temp_id
  //     };
  //     dispatch(PlanningTemplatesMiddleware.addPublicTemplates(eventData))
  //       .then(() => setevent(null))
  //       .catch(err => {
  //         setevent(null);
  //         console.log(err);
  //       });
  //   }
  // };
  const addPlanningTemplate = (id) => {
    let eventData = {
      event_id: EventDetails?.id,
      temp_id: id,
      shared_planning_template_id: EventDetails?.template?.id,
    };
    dispatch(PlanningTemplatesMiddleware.addPublicTemplates(eventData))
      .then(() => setevent(null))
      .catch((err) => {
        setevent(null);
        console.log(err);
      });
  };
  return (
    <>
      <Row
        className={styles.headingRow}
        justify={"space-between"}
        align={"middle"}
        gutter={[0, 16]}
      >
        {/* <Col xs={24} sm={14} md={12} lg={10}>
          <SearchInput placeholder="Search" />
        </Col> */}
        {/* <div className={styles.addTemplates}>
        <Col xs={12} md={15} lg={10} >
          <SubmitButton
            title="Add Template"
            onClick={() => setAddTemplate(true)}
          />
        </Col>
        </div> */}
      </Row>
      <List
        header={<TableHeader item={headerRow} />}
        className={styles.list}
        itemLayout={width > 991 ? "horizontal" : "vertical"}
        dataSource={PublicTemplates}
        renderItem={(item, i) => (
          <RenderTemplate
            item={item}
            index={i}
            setAddTemplate={setAddTemplate}
            setevent={setevent}
            addPlanningTemplate={addPlanningTemplate}
            eventData={state?.eventData}
          />
        )}
      />
      <Modal
        isModalOpen={addTemplate}
        setIsModalOpen={setAddTemplate}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Create Template"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >
            {/* <InputField
              label="Title"
              name="title"
              placeholder="Engagement Ceremony"
            />
            <Dropdown
              label="Event Type"
              name="eventType"
              placeholder="Party"
              options={[{ value: "Party", option: "Party" }]}
            /> */}
            <Dropdown
              label="Event List"
              name="eventList"
              placeholder="Wedding Party"
              object={VendorEvents}
              onChange={(e) => setevent({ ...event, selected_event: e })}
            />
          </Space>
          <SubmitButton
            title="Add Template"
            btnClass={styles.modalBtnTemplate}
            // onClick={() => {
            //   addPlanningTemplate(item?.id)
            // }}
          />
        </div>
      </Modal>
    </>
  );
};

export default PublicTemplates;
